module.exports = "pegasus/assets/tech/update/100.png";